import { IconBrandGoogle, IconSparkles } from "@tabler/icons-react";

/**
 * Google's AI surfaces, which are not LLM providers and do not behave like them.
 *
 * Two differences matter:
 *  - They have no SVG logo, so they render a Tabler icon. The icons must differ from each
 *    other — two identical Google marks make AI Overview and AI Mode indistinguishable in
 *    a result card.
 *  - They are keyed by a stable string, not a Mongo id. LlmResponseAnalysis.LlmIdPath holds
 *    a document id for LLM providers but this literal for a Google surface, and the backend
 *    filters it with Eq("LlmIdPath.0", value). See DataForSeoSurfaceSpec.ProviderId.
 */
export const GOOGLE_SURFACES = {
  "google-aio": { label: "Google AI Overview", Icon: IconBrandGoogle },
  "google-ai-mode": { label: "Google AI Mode", Icon: IconSparkles },
};

const surfaceByName = Object.fromEntries(
  Object.entries(GOOGLE_SURFACES).map(([key, v]) => [v.label, { key, ...v }]),
);

/** Resolves a surface from either its string key or its display name. */
export function resolveSurface(value) {
  if (!value) return null;
  if (GOOGLE_SURFACES[value]) return { key: value, ...GOOGLE_SURFACES[value] };
  return surfaceByName[value] ?? null;
}

/**
 * The value to filter analytics by for a given provider document. Passing a Google
 * surface's document id here would silently match nothing.
 */
export function providerFilterValue(provider) {
  return surfaceByName[provider?.name]?.key ?? provider?.id;
}
